import React from 'react'
import MasterLayout from '../../masterLayout/MasterLayout'
import Breadcrumb from '../../components/Breadcrumb'
import SliderManagement from '../../components/HomePageSliderManagement/SliderManagement'

const HomePageSliderManagement = () => {
    return (

        <>
            <MasterLayout>

                <Breadcrumb title='Home Page Slider Management' />

                <SliderManagement />

            </MasterLayout>
        </>
    )
}

export default HomePageSliderManagement